/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/const/Strings.ts
 * @create:      2018-08-30 16:08:53.191
 * @modify:      2025-07-11 20:47:10.772
 * @version:     6.0.0
 * @times:       25
 * @lines:       194
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/


/**
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_Empty = "";

/**
 * @version 1.0.0
 * @since 1.0.10
 */
export const Strings_WhiteSpace = " ";

/**
 * @version 1.0.0
 * @since 1.0.10
 */
export const Strings_Tab = "\t";

/**
 * \n, (Line Feed) Used as a new line character in Unix/Mac OS X
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_LF = "\n";

/**
 * \r, (Carriage Return) Used as a new line character in Mac OS before X
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_CR = "\r";

/**
 * \r\n, Used as a new line character in Windows
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_CR_LF = "\r\n";

/**
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_HTML_BR = "<br>";

/**
 * non-breaking space
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_HTML_NBSP = "&nbsp;";

/**
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_LowercaseLetters = "abcdefghijklmnopqrstuvwxyz";

/**
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_UppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

/**
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_Numbers = "0123456789";

/**
 * @version 1.0.0
 * @since 1.0.5
 * @see https://www.owasp.org/index.php/Password_special_characters
 */
export const Strings_PasswordSpecialCharacters =
    " !\"#$%&'()*+,-./:;<=>?@[]^_`{|}~";

/**
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_Slash = "/";

/**
 * @version 1.0.0
 * @since 1.0.5
 */
export const Strings_BackSlash = "\\";

/**
 * @version 1.0.0
 * @since 1.0.6
 */
export const Strings_DoubleQuotes = "\"";

/**
 * @version 1.0.0
 * @since 1.0.9
 */
export const Strings_RunningMode = "RunningMode";

/**
 * @version 1.0.0
 * @since 1.0.9
 */
export const Strings_Development = "development";

/**
 * @version 1.0.0
 * @since 1.0.9
 */
export const Strings_Production = "production";

/**
 * @version 1.0.0
 * @since 1.0.12
 */
export const Strings_Dot = ".";

/**
 * @version 1.0.0
 * @since 1.1.1
 */
export const Strings_Unknown = "Unknown";

/**
 * @version 1.0.0
 * @since 1.1.1
 */
export const Strings_Success = "Success";

/**
 * @version 1.0.0
 * @since 1.1.1
 */
export const Strings_Failure = "Failure";

/**
 * @version 1.0.0
 * @since 1.1.3
 */
export const Strings_true = "true";

/**
 * @version 1.0.0
 * @since 1.1.3
 */
export const Strings_false = "false";

/**
 * @version 2019-03-21
 * @since 1.1.19
 */
export const Strings_BREAK_LINE_REGEXP = /\r\n|\r|\n/g;

export const Strings_BEGIN_PUBLIC_KEY = "-----BEGIN PUBLIC KEY-----";
export const Strings_END_PUBLIC_KEY = "-----END PUBLIC KEY-----";
export const Strings_BEGIN_PRIVATE_KEY = "-----BEGIN PRIVATE KEY-----";
export const Strings_END_PRIVATE_KEY = "-----END PRIVATE KEY-----";
